import { Stack, Tooltip } from '@mui/material';
import DarkButton from './DarkButton';

interface RaiseQMButtonProps {
  isOnline: boolean;
  isAnyPrinterDisabled: boolean;
  setOpenRaiseQM: (value: boolean) => void;
  label?: string;
  onClick?: () => void;
}

export default function RaiseQMButton({
  isOnline,
  isAnyPrinterDisabled,
  setOpenRaiseQM,
  label = 'Raise a QM',
  onClick
}: RaiseQMButtonProps) {
  return (
    <Stack justifyContent="center">
      {isOnline ? (
        <Tooltip
          enterTouchDelay={0}
          title={
            isAnyPrinterDisabled
              ? 'A Printer in your settings is disabled, some functionality is restricted. Please select a new printer in Settings.'
              : ''
          }>
          <DarkButton
            variant="outlined"
            onClick={() => (onClick ? onClick() : setOpenRaiseQM(!isAnyPrinterDisabled))}
            sx={{ color: 'white' }}>
            {label}
          </DarkButton>
        </Tooltip>
      ) : (
        <Tooltip enterTouchDelay={0} title="You are offline. This feature is not available when offline.">
          <DarkButton variant="outlined">{label}</DarkButton>
        </Tooltip>
      )}
    </Stack>
  );
}
